module.exports = __webpack_public_path__ + "c9833ecde3db58e76bf036819821f477.svg";